<div class="map-container">
  <!-- The spot map, defer loading to make sure it is not loaded on the server. -->
  @defer {
  <app-spot-map
    #spotMap
    id="spotMap"
    [selectedSpot]="selectedSpot"
    (selectedSpotChange)="selectedSpot = $event; updateMapURL()"
    [centerStart]="{
      lat: 48.6270939,
      lng: 2.4305363,
    }"
    [(isEditing)]="isEditing"
    [(mapStyle)]="mapStyle"
    [showAmenities]="showAmenities()"
    (visibleSpotsChange)="setVisibleSpots($event)"
    (hightlightedSpotsChange)="highlightedSpots = $event"
    (hasGeolocationChange)="askedGeoPermission = true; hasGeolocation = $event"
  ></app-spot-map>
  }

  <div class="search-group">
    <div class="d-flex flex-row gap-3">
      @if(alainMode) {
      <div class="spacer d-block d-md-none" style="width: 56px"></div>
      }
      <app-search-field
        class="w-100 mat-elevation-z3"
        (spotSelected)="openSpotOrGooglePlace($event)"
      ></app-search-field>
    </div>

    @if(spotMap) { @if(selectedSpot) {
    <div class="info-panel d-none d-md-block spot-preview-container p-1 pt-3">
      <app-spot-details
        @fadeInOut
        #spotDetail
        [spot]="selectedSpot"
        [border]="false"
        [dismissable]="true"
        [infoOnly]="false"
        [editable]="true"
        [isEditing]="isEditing"
        (isEditingChange)="$event ? spotMap.startEdit() : spotMap.discardEdit()"
        (dismiss)="spotMap.closeSpot()"
        (addBoundsClick)="spotMap.addBounds()"
        (focusClick)="spotMap.focusSpot(selectedSpot)"
        (saveClick)="spotMap.saveSpot($event)"
      ></app-spot-details>
    </div>
    } @else {
    <div class="info-panel d-none d-md-block p-3">
      <app-spot-list
        @fadeInOut
        [spots]="visibleSpots"
        [highlightedSpots]="highlightedSpots"
      ></app-spot-list>
    </div>
    }
    <app-bottom-sheet #bottomSheet class="d-md-none flex-grow-1">
      @if(selectedSpot) {
      <div class="spot-preview-container">
        <app-spot-details
          @fadeInOut
          #spotDetail
          [spot]="selectedSpot"
          [border]="false"
          [dismissable]="true"
          [infoOnly]="false"
          [editable]="true"
          [isEditing]="isEditing"
          (isEditingChange)="
            $event ? spotMap.startEdit() : spotMap.discardEdit()
          "
          (dismiss)="spotMap.closeSpot()"
          (addBoundsClick)="spotMap.addBounds()"
          (focusClick)="spotMap.focusSpot(selectedSpot)"
          (saveClick)="spotMap.saveSpot($event)"
        ></app-spot-details>
      </div>
      } @else {
      <div class="px-3">
        <app-spot-list
          @fadeInOut
          [spots]="visibleSpots"
          [highlightedSpots]="highlightedSpots"
        ></app-spot-list>
      </div>
      }
    </app-bottom-sheet>
    }
  </div>

  <!-- Search option chips -->
  <!-- @if(authService.isSignedIn && !isEditing) {
  <mat-chip-listbox class="search-option-chips">
    <mat-chip-option color="">Unvisited</mat-chip-option>
    <mat-chip-option color="primary" leadingIcon="flag"
      >Visited</mat-chip-option
    >
  </mat-chip-listbox>
  } -->

  <div class="mini-fabs">
    <button
      mat-mini-fab
      #mapStyleFab
      id="mapStyleFab"
      (click)="spotMap ? spotMap.toggleMapStyle() : null"
      color="primary"
      i18n-matTootlip
      [matTooltip]="
        mapStyle === 'roadmap' ? 'Show satellite map' : 'Show roadmap'
      "
      matTooltipPosition="left"
      matTooltipShowDelay="500"
    >
      <mat-icon>
        {{ mapStyle === "roadmap" ? "terrain" : "map" }}
      </mat-icon>
    </button>

    <button
      mat-mini-fab
      #geolocationFab
      id="geolocationFab"
      color="primary"
      (click)="spotMap ? spotMap.focusOnGeolocation() : null"
      i18n-matTootlip
      matTooltip="Go to your location"
      matTooltipPosition="left"
      matTooltipShowDelay="500"
    >
      <mat-icon>
        {{
          askedGeoPermission
            ? hasGeolocation
              ? "my_location"
              : "location_disabled"
            : "location_searching"
        }}
      </mat-icon>
    </button>

    <!-- Show amenity markers mini FAB-->
    <button
      mat-mini-fab
      #amenitiesFab
      id="amenitiesFab"
      color="primary"
      (click)="showAmenities.set(!showAmenities())"
      [disabled]="spotMap ? spotMap.mapZoom < 16 : true"
      i18n-matTootlip
      [matTooltip]="
        showAmenities() ? 'Hide amenity markers' : 'Show amenity markers'
      "
      matTooltipPosition="left"
      matTooltipShowDelay="500"
    >
      <mat-icon>
        {{ showAmenities() ? "location_off" : "location_on" }}
      </mat-icon>
    </button>
  </div>

  @if(authService.isSignedIn && !isEditing) {
  <!-- Add / import spots speed dial-->
  <!-- <app-speed-dial-fab
    #createSpotSpeedDial
    id="createSpotSpeedDial"
    [buttonConfig]="speedDialButtonConfig"
    [openOnHover]="true"
    [rotationDegrees]="0"
    (mainFabClick)="spotMap.createSpot()"
    (miniFabClick)="speedDialMiniFabClick($event)"
  ></app-speed-dial-fab> -->
  <button
    @fadeInOut
    mat-fab
    #createSpotSpeedDial
    id="createSpotSpeedDial"
    color="primary"
    (click)="spotMap ? spotMap.createSpot() : null"
  >
    <mat-icon> add_location </mat-icon>
  </button>
  }

  <!-- <mat-menu #searchUserMatMenu="matMenu">
    <app-user-menu-content></app-user-menu-content>
  </mat-menu> -->
</div>
